import { CSSProperties, MouseEvent, ReactNode, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cns from 'classnames';
import { Button } from '../Button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '../Dialog';
import S from './ConfirmDialog.module.scss';
export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    maxWidth = '320px',
    topSlot,
    title,
    content,
    keyboard = true,
    dimmed = true,
    useOutSideClick = false,
    confirmVariant = 'primary',
    cancelText,
    confirmText,
    hideCancelButton = false,
    showCloseButton = false,
    focus,
    onClose,
    onConfirm,
    ...rest
  } = props;
  const {
    t
  } = useTranslation(['common']);
  const confirmButtonRef = useRef<HTMLButtonElement>(null);
  const handleClose = () => {
    onClose && onClose();
  };
  const handleCloseDialog = () => {
    if (!useOutSideClick) {
      return;
    }
    handleClose();
  };
  useEffect(() => {
    if (focus && confirmButtonRef.current) {
      confirmButtonRef.current.focus();
    }
  }, [focus, confirmButtonRef]);
  return <Dialog maxWidth={maxWidth} onClose={handleCloseDialog} onKeyDown={e => !keyboard && e.stopPropagation()} initialFocus={confirmButtonRef} open {...rest} data-sentry-element="Dialog" data-sentry-component="ConfirmDialog" data-sentry-source-file="ConfirmDialog.tsx">
      {dimmed && <DialogOverlay />}
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="ConfirmDialog.tsx">
        <DialogHeader onClose={showCloseButton ? handleClose : undefined} closeAriaLabel={String(t('common:close', '닫기'))} topSlot={topSlot} className={cns(content === undefined && S.header)} data-sentry-element="DialogHeader" data-sentry-source-file="ConfirmDialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ConfirmDialog.tsx">{title}</DialogTitle>
        </DialogHeader>
        {content && <DialogContent preLine>{content}</DialogContent>}
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="ConfirmDialog.tsx">
          {!hideCancelButton && <Button variant="sub" size="md" onClick={handleClose}>
              {cancelText ?? t('common:cancel')}
            </Button>}
          <Button ref={confirmButtonRef} variant={confirmVariant} size="md" onClick={onConfirm} data-sentry-element="Button" data-sentry-source-file="ConfirmDialog.tsx">
            {confirmText ?? t('common:confirm')}
          </Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export type ConfirmDialogProps = {
  maxWidth?: string;
  topSlot?: ReactNode;
  title: ReactNode;
  content?: ReactNode;
  dimmed?: boolean;
  keyboard?: boolean;
  useOutSideClick?: boolean;
  cancelText?: ReactNode;
  confirmText?: ReactNode;
  confirmVariant?: 'primary' | 'alert';
  hideCancelButton?: boolean;
  showCloseButton?: boolean;
  style?: CSSProperties;
  onClose?: () => void;
  onConfirm?: (e: MouseEvent<HTMLButtonElement>) => void;
  focus?: boolean;
};